import { ShortenPerson } from 'models/profile.model';
import { FC } from 'react';
import MyProfile from './me';

const IndexMyProfile: FC<{ currentUser: ShortenPerson }> = ({ currentUser }) => {
  return <MyProfile currentUser={currentUser} />;
};

export default IndexMyProfile;
